export const EMAIL_REGEX = /^[\w.%+-]+@[\w.-]+\.[a-zA-Z]{2,4}$/
export const PHONE_NUMBER_REGEX = /^(\+\d{1,3}[- ]?)?\d{10}$/
